// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const meowstic_female: PokeData = {
  "id": 10025,
  "name": "meowstic-female",
  "height": 6,
  "weight": 85,
  "base_experience": 163,
  "types": [
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "scratch",
    "leer",
    "psybeam",
    "confusion",
    "psychic",
    "light-screen",
    "reflect",
    "shadow-ball",
    "future-sight",
    "fake-out",
    "role-play",
    "signal-beam",
    "extrasensory",
    "covet",
    "magical-leaf",
    "me-first",
    "sucker-punch",
    "charge-beam",
    "psyshock",
    "stored-power",
    "disarming-voice"
  ],
  "moves": [
    "scratch",
    "leer",
    "psychic",
    "reflect",
    "shadow-ball",
    "future-sight",
    "psychic-terrain",
    "psychic-fangs",
    "calm-mind",
    "kinesis",
    "psy-pulse",
    "healing-wish",
    "prismatic-cage"
  ],
  "evolution_chain": {
    "id": 348,
    "item": null,
    "species": [
      {
        "name": "espurr",
        "order": 678,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "meowstic",
        "order": 679,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 677,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 25,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 116,
    "speed": 158,
    "ability_power": 126
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
